"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockVerpackung = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const Verpackung_1 = require("./Verpackung");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
class MockVerpackung extends Verpackung_1.Verpackung {
    constructor(id) {
        super({
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            Typ: 'MockVerpackung',
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
        this.className = 'MockVerpackung';
        this.id = id;
    }
    clone() {
        return undefined;
    }
    duplicate() {
        return undefined;
    }
    getMaxLength() {
        return undefined;
    }
    getVolume() {
        return undefined;
    }
}
exports.MockVerpackung = MockVerpackung;
//# sourceMappingURL=MockVerpackung.js.map